import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Could not send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        {!sent ? (
          <>
            <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-3">Forgotten</div>
            <h1 className="font-serif-h font-light text-4xl text-stone-900">Reset your password</h1>
            <p className="mt-4 text-stone-600 font-light text-sm leading-relaxed">
              Enter your email and we'll send you a link to set a new password. The link expires in 30 minutes.
            </p>
            <form onSubmit={submit} className="mt-10" data-testid="forgot-form">
              <label className="text-[11px] tracking-overline uppercase text-stone-500">Email</label>
              <input required type="email" value={email}
                     onChange={(e) => setEmail(e.target.value)}
                     className="input-line" data-testid="forgot-email" />
              <button disabled={loading} className="btn-ink w-full justify-center mt-8 disabled:opacity-50" data-testid="forgot-submit">
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
            <div className="mt-8 text-sm text-stone-600 text-center">
              <Link to="/login" className="text-[#D4AF37] hover:underline">← Back to sign in</Link>
            </div>
          </>
        ) : (
          <div className="text-center" data-testid="forgot-sent">
            <CheckCircle2 size={48} strokeWidth={1} className="mx-auto text-[#D4AF37]" />
            <h1 className="font-serif-h font-light text-3xl text-stone-900 mt-6">Check your inbox</h1>
            <p className="mt-4 text-stone-600 font-light text-sm leading-relaxed">
              If an account exists for <b>{email}</b>, a reset link is on its way. The link will expire in 30 minutes.
            </p>
            <p className="mt-3 text-xs text-stone-500">
              Didn't get it? Check spam, or <button onClick={() => setSent(false)} className="text-[#D4AF37] hover:underline">try again</button>.
            </p>
            <Link to="/login" className="btn-gold-outline mt-10 inline-flex">Back to Sign In</Link>
          </div>
        )}
      </div>
    </div>
  );
}
